import React from 'react'
import { observable } from 'mobx'

const PrefixContext = React.createContext(observable(new Map()))

export const Provider = PrefixContext.Provider
export const Consumer = PrefixContext.Consumer

export default PrefixContext
